import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { setLanguage } from '../store/slices/authSlice';

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state: RootState) => state.auth.user?.language || 'ru');

  // Синхронизируем язык из Redux с i18next при инициализации
  React.useEffect(() => {
    if (currentLanguage && i18n.language !== currentLanguage) {
      i18n.changeLanguage(currentLanguage);
    }
  }, [currentLanguage, i18n]);

  const changeLanguage = async (language: string) => {
    try {
      await i18n.changeLanguage(language);
      dispatch(setLanguage(language));
      
      // Отправляем запрос на сервер для обновления языка пользователя
      const token = localStorage.getItem('token');
      if (token) {
        await fetch('/api/v1/user/language', {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ language }),
        });
      }
    } catch (error) {
      console.error('Ошибка при смене языка:', error);
    }
  };

  return {
    currentLanguage,
    changeLanguage,
    isReady: i18n.isInitialized,
  };
}; 